import { useTranslation } from '../../../hooks/useTranslation';
import { addDays, isWithinInterval, set } from 'date-fns';

const { t } = useTranslation();

export const validateAddress = (addressLine1?: string) => {
  if (!addressLine1) {
    return t('SERVICE_STREET_ADDRESS_ERROR');
  }
  return null;
};

export const validateStartDate = (date?: Date): string | null => {
  if (!date) {
    return t('ERROR_ENTER_START_SERVICE_DATE');
  }

  const start = set(new Date(), {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  const end = addDays(start, 60);

  if (!isWithinInterval(date, { start, end: addDays(start, 60) })) {
    return t('ERROR_ENTER_START_SERVICE_DATE');
  }

  return null;
};
